import { createContext } from "react";

const DF_OT0016Context = createContext();

export { DF_OT0016Context };
